function normalizeValue(value) {
  if (value === null || value === undefined) return '';
  return String(value).trim().toLowerCase();
}

export function buildValueSet(samples) {
  const set = new Set();
  for (const s of samples || []) {
    const v = normalizeValue(typeof s === 'object' && s !== null ? s.value : s);
    if (v) set.add(v);
  }
  return set;
}

export function jaccard(setA, setB) {
  if (setA.size === 0 && setB.size === 0) return 0;
  let inter = 0;
  const [small, large] = setA.size < setB.size ? [setA, setB] : [setB, setA];
  for (const v of small) if (large.has(v)) inter += 1;
  return inter / (setA.size + setB.size - inter);
}

export function valueSimilarity(columnSample, fieldDomain) {
  if (!Array.isArray(fieldDomain) || fieldDomain.length === 0) return 0;
  const colSet = buildValueSet(columnSample);
  const domSet = new Set();
  for (const entry of fieldDomain) {
    const k = normalizeValue(entry.key);
    const v = normalizeValue(entry.value);
    if (k) domSet.add(k);
    if (v) domSet.add(v);
  }
  return jaccard(colSet, domSet);
}
